import { Injectable } from '@angular/core';
import {ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

import * as _ from 'underscore';

@Injectable()
export class BeeztelCodesService {

    constructor(private api: ApiService) { }

    getBeeztelCodes(): Observable<any> {
        return this.api.get('vna/tools/beeztel-codes-default');
    }

    getPortalBeeztelCodes(portal: string): Observable<any> {
        return this.api.get('vna/tools/beeztel-codes/' + portal);
    }

    getStatusList(){
        return this.api.get('misc/vna/phone-response-status');
    }

    getStatusDoiList(){
        return this.api.get('misc/vna/phone-response-status', { 'dois' : 1 });
    }

    postNewCode(data: Object): Observable<any> {
        return this.api.post('vna/tools/beeztel-codes/create', data);
    }

    putExistingCode(data: Object): Observable<any> {
        return this.api.customPut('vna/tools/beeztel-codes/update', data);
    }

    deleteExistingCode(data: Object): Observable<any> {
        return this.api.customRemove('vna/tools/beeztel-codes/' + data['pk'] + '/delete');
    }

    parseDataForCreate(data: Object, portal: string): Object {
        var formValues = Object.assign({}, data);
        if(formValues['all_portals'] == '0'){
            formValues['portal'] = portal;
        }

        delete formValues['all_portals'];
        return formValues;
    }

    parseDataForUpdate(data: Object, pk: number): Object {
        var formValues = Object.assign({}, data);
        formValues['pk'] = pk;
        delete formValues['all_portals'];

        return formValues;
    }

    getMappingChanges(portal: string): Observable<any> {
        return this.api.get('vna/tools/beeztel-status-attempts', {portal : portal});
    }

    deleteExistingMappingCode(pk: number): Observable<any> {
        return this.api.remove('vna/tools/beeztel-status-attempts', pk);
    }

    createMappingChange(data: Object): Observable<any> {
        return this.api.post('vna/tools/beeztel-status-attempts', data);
    }

    updateMappingChange(pk: number, data: Object): Observable<any> {
        return this.api.put('vna/tools/beeztel-status-attempts', pk, data);
    }

    parseForCreateMappingChange(data: Object): Object {
        var formValues = Object.assign({}, data);
        if(_.isArray(formValues['allowed_codes'])){
            formValues['allowed_codes'] = formValues['allowed_codes'].map( (obj) => { return obj.value } );
        }

        return formValues;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/beeztel-codes/services/beeztel-codes.service.ts